<span class="title-menu icon ico-link">Enlaces aplicaciones</span>
<ul class="menu menu-sidebar">
    <li>
        <a (click)="optionSelected($event, 'FBI Clientes', mobileAppSelector.appGroup.FBIClients)">FBI Clientes</a>
    </li>
    <li>
        <a (click)="optionSelected($event, 'FBI Talento', mobileAppSelector.appGroup.FBITalent)">FBI Talento</a>
    </li>
    @if (groupApps[appSelector.appGroup.Administration] > 0) {
      <li>
        <a (click)="optionSelected($event, 'Administrativo', mobileAppSelector.appGroup.Administration)">Administrativo</a>
      </li>
    }
</ul>
<app-selection-dialog #mobileAppSelector></app-selection-dialog>
